// src/api/assignmentApi.js

import axiosInstance from './axiosInstance'; 

export const fetchAssignmentType = async () => {
  const response = await axiosInstance.get('/assignment-types/');
  return response.data;
};